// extracted by mini-css-extract-plugin
export var pageGradient = "styles-module--pageGradient--cwe6K";
export var linkCardBackground = "styles-module--linkCardBackground--+wa6s";